export class BPChangeValid {
  static validCheck({ middleLang, IOId, BPId }) {
    const matchedIO = middleLang.filter(o => o.IOId === IOId)
    if (!matchedIO.length) return false
    const matchedBP = matchedIO[0].BPIds.filter(o => o.BPId === BPId)
    if (!matchedBP.length) return false
    return matchedBP[0].selected === false
  }
}

export const bpChangeValid = ({ middleLang, IOId, BPId }) => {
  return BPChangeValid.validCheck({ middleLang, IOId, BPId })
}
